import React from "react";
import { useEffect,useRef,useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Navigate, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnUi from "Utils/MbpAthn";
import MgpStore from "Stores/Store";
import MembIdntMthdChngApi from "Apis/MembIdntMthdChngApi";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import ApiResultModal from "Components/ApiResultModal";
import MembMktgAgreInqApi from "Apis/MembMktgAgreInqApi";
import MembMktgAgreChngApi from "Apis/MembMktgAgreChngApi";
import { refererGetApi } from "Apis/refererApi";
import ApiError from "Utils/ApiError";
import DaumPostcode from 'react-daum-postcode';
import MembIdntMktgAddrApi from "Apis/MembIdntMktgAddrApi";
import MembAddrRegApi from "Apis/MembAddrRegApi";

const ENABLE_MKTG_AGREE_CHANGE = false; // 마케팅 동의 변경 기능 활성화 여부 (true: 활성화, false: 비활성화)

const renderTextWithBr = (text: string) => {
    return text.split(/<br\s*\/?\s*>/gi).map((line, idx, arr) => (
        <React.Fragment key={`${line}-${idx}`}>
            {line}
            {idx < arr.length - 1 && <br />}
        </React.Fragment>
    ));
};

const getSmsApplyDateText = (apiBody: any) => {
    return (
        apiBody?.smsNtfyChngDtime ||
        apiBody?.smsNtfyRecvChngDtime ||
        apiBody?.smsNtfyAplyDate ||
        apiBody?.smsAplyDate ||
        apiBody?.aplyDate ||
        ""
    );
};


const MembIngameIdntMthdChngUi = () => {
    const langData:any = useOutletContext();
    const location = useLocation();
    const txt = {
        pageTitle: langData?.MYPAGE_INGAME_PRIZE_RCV_PAGE_TITL_00 || "경품 수령 정보 입력",
        authTitle: langData?.MYPAGE_INGAME_PRIZE_RCV_AUTH_TITL_00 || langData?.MYPAGE_MENU_ATHN_CHNG_BTN_00 || "휴대폰 인증",
        authDesc: langData?.MYPAGE_INGAME_PRIZE_RCV_AUTH_DESC_00 || "본인 명의의 휴대폰으로 인증해 주세요.",
        authDesc2: langData?.MYPAGE_INGAME_PRIZE_RCV_AUTH_DESC_01 || "인증된 휴대폰 번호로 상품 수령 안내가 발송됩니다.",
        smsOnlyTitle: langData?.MYPAGE_MAIN_SMS_NTFY_LBL_00 || "SMS 알림 수신 동의",
        smsOnlyDesc: langData?.MYPAGE_INGAME_PRIZE_RCV_SMS_ONLY_DESC_00 || "휴대폰 인증은 완료되어 SMS 알림 수신 동의만 진행하면 됩니다.",
        addrTitle: langData?.MYPAGE_INGAME_PRIZE_RCV_ADDR_TITL_00 || "배송지 정보 입력",
        addrDesc: langData?.MYPAGE_INGAME_PRIZE_RCV_ADDR_DESC_00 || "실물 경품을 수령하실 경우 경품 발송을 위한<br />배송지 정보를 입력해 주세요.",
        zipPlaceholder: langData?.MYPAGE_INGAME_PRIZE_RCV_ADDR_PLCH_00 || "우편번호",
        zipSearchBtn: langData?.MYPAGE_INGAME_PRIZE_RCV_ADDR_SRCH_BTN_00 || "우편번호 검색",
        roadPlaceholder: langData?.MYPAGE_INGAME_PRIZE_RCV_ADDR_PLCH_01 || "도로명 주소",
        modalTitle: langData?.MYPAGE_INGAME_PRIZE_RCV_ADDR_MODAL_TITL_00 || "주소 찾기",
        closeBtn: langData?.COMM_MAIN_CLS_MAIN_BTN_00 || "닫기",
        detailPlaceholder: langData?.MYPAGE_INGAME_PRIZE_RCV_ADDR_PLCH_02 || "상세주소",
        addrAgreeLabel: langData?.MYPAGE_INGAME_PRIZE_RCV_ADDR_AGRE_LBL_00 || "[ 선택 ] 배송지 정보 수집 · 이용에 동의하고 주소를 입력합니다.",
        confirmBtn: langData?.COMM_MAIN_CHK_MAIN_BTN_00 || "확인",
        successMsg: langData?.MYPAGE_INGAME_PRIZE_RCV_SAVE_SUCC_MSG_00 || "변경이 완료되었습니다.",
        authDone: langData?.MYPAGE_INGAME_PRIZE_RCV_AUTH_DONE_00 || "인증완료",
        smsAgreeDone: langData?.MYPAGE_INGAME_PRIZE_RCV_SMS_AGRE_DONE_00 || "동의 완료",
        applyDateLabel: langData?.COMM_MAIN_APLY_DTIME_LBL_00 || "적용일",
        smsAgreeNeedMsg: langData?.MYPAGE_INGAME_PRIZE_RCV_SMS_AGRE_NEED_MSG_00 || "SMS 알림 수신 동의가 필요합니다.",
    };
    const navigate = useNavigate();
    const addrYnParam = new URLSearchParams(location.search).get("addrYn");
    const showAddrSection = (addrYnParam || "N").toUpperCase() === "Y";

    const isCompleteAndNavigate = (apiBody: any) => {
        if (!ENABLE_MKTG_AGREE_CHANGE) {
            return false;
        }

        const isAuthDone = apiBody?.mbpIdntYn === "Y" && apiBody?.smsNtfyRecvYn === "Y";
        const isAddrDone = !showAddrSection || apiBody?.addrRegYn === "Y";

        if (isAuthDone && isAddrDone) {
            navigate("/Mypage/ingameidntmthdsuss");
            return true;
        }
        return false;
    };

    const refreshMembIdntMktgAddr = async () => {
        const resp = await MembIdntMktgAddrApi();
        if (resp?.apiHdr?.code === "MEMB0000") {
            if (!hasLoadedInitialIdntInfo.current) {
                hasLoadedInitialIdntInfo.current = true;
                setIsInitialPhoneAuthed(resp.apiBody?.mbpIdntYn === "Y");
            }
            isCompleteAndNavigate(resp.apiBody);
        }
        return resp;
    };

    const runMktgAgreeChangeIfEnabled = async () => {
        if (!ENABLE_MKTG_AGREE_CHANGE) {
            return false;
        }

        const resp = await MembMktgAgreChngApi(null, smsNtfyRecvYnRef.current);
        switch (resp.apiHdr.code) {
            case "MEMB0000":
                openResultModal(txt.successMsg, () => navigate(referrerUrl));
                return true;
            default:
                ApiError(langData, resp.apiHdr.code);
                return true;
        }
    };

    const submitSmsConsentOnly = async () => {
        if (smsNtfyRecvYnRef.current !== "Y") {
            openResultModal(txt.smsAgreeNeedMsg);
            return;
        }

        const resp = await MembMktgAgreChngApi(null, smsNtfyRecvYnRef.current);
        switch (resp?.apiHdr?.code) {
            case "MEMB0000":
                const nextSmsYn = resp.apiBody?.smsNtfyRecvYn ?? "Y";
                setSmsNtfyRecvYn(nextSmsYn);
                setSmsNtfyRecvYnDraft(nextSmsYn);
                smsNtfyRecvYnRef.current = nextSmsYn;
                setIsInitialSmsAgreed(nextSmsYn === "Y");
                setSmsApplyDateText(getSmsApplyDateText(resp.apiBody));
                await refreshMembIdntMktgAddr();
                openResultModal(txt.successMsg);
                return;
            default:
                ApiError(langData, resp?.apiHdr?.code);
                return;
        }
    };

    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [emlNtfyRecvYn,setEmlNtfyRecvYn] = useState("N");
    const [smsNtfyRecvYn,setSmsNtfyRecvYn] = useState("N");
    const [smsNtfyRecvYnDraft, setSmsNtfyRecvYnDraft] = useState("N");
    const [isInitialPhoneAuthed, setIsInitialPhoneAuthed] = useState(false);
    const [isInitialSmsAgreed, setIsInitialSmsAgreed] = useState(false);
    const [smsApplyDateText, setSmsApplyDateText] = useState("");
    const [addrInfoAgreeYn, setAddrInfoAgreeYn] = useState("N");
    const [referrerUrl, setReferrerUrl] = useState("/");
    const emlNtfyRecvYnRef = useRef("N");
    const smsNtfyRecvYnRef = useRef("N");
    const [zipCode, setZipcode] = useState<string>("");
    const [roadAddress, setRoadAddress] = useState<string>("");
    const [detailAddress, setDetailAddress] = useState<string>("");    // 추가
    const [isOpen, setIsOpen] = useState<boolean>(false); //추가
    const AgreSmsNtfyFunc = (e: React.ChangeEvent<HTMLInputElement>) => {
        const nextYn = e.target.checked ? "Y" : "N";
        setSmsNtfyRecvYnDraft(nextYn);
        smsNtfyRecvYnRef.current = nextYn;
    };
    const AgreAddrInfoFunc = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAddrInfoAgreeYn(e.target.checked ? "Y" : "N");
    };
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const hasLoadedInitialIdntInfo = useRef(false);
    const hasLoadedInitialMktgInfo = useRef(false);
    const isSmsOnlyMode = isInitialPhoneAuthed && smsNtfyRecvYn !== "Y";

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    useEffect(() => {
        emlNtfyRecvYnRef.current = emlNtfyRecvYn;
    }, [emlNtfyRecvYn]);

    useEffect(() => {
        smsNtfyRecvYnRef.current = smsNtfyRecvYnDraft;
    }, [smsNtfyRecvYnDraft]);
    const completeHandler = (data:any) =>{
        setZipcode(data.zonecode);
        setRoadAddress(data.roadAddress);
        setIsOpen(false); //추가
    }
     // 검색 클릭
    const openPostcodeModal = () => {
        setIsOpen(true);
    }

    // 상세 주소검색 event
    const changeHandler = (e:React.ChangeEvent<HTMLInputElement>) =>{
        setDetailAddress(e.target.value);
    }
    // 추가
    const clickHandler = () =>{
        MembAddrRegApi(zipCode, roadAddress, detailAddress)
        .then(async (resp) => {
            console.log(resp);
            if (resp?.apiHdr?.code === "MEMB0000") {
                await refreshMembIdntMktgAddr();
            }
        });
    }

    useEffect(()=>{
        refreshMembIdntMktgAddr();
        refererGetApi()
        .then((resp) => {
            if(resp.apiHdr.code == "ATHN0000") {
                setReferrerUrl(resp.apiBody.redirectUri);
            }
            return;
        });
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then(async (resp) => {
                if(resp.apiHdr.code == "ATHN0000") {
                    await refreshMembIdntMktgAddr();
                    const handledByMktgFlow = await runMktgAgreeChangeIfEnabled();
                    if (!handledByMktgFlow) {
                        openResultModal(txt.successMsg);
                    }
                }else{
                    openResultModal((langData&&langData.GLB_ATHN_FAIL_DESC_00) + resp.apiHdr.code);
                }
            });
            
        }
        window.kmcRespFunc = kmcRespFunc;
        MembMktgAgreInqApi()
        .then((resp) => {
            setEmlNtfyRecvYn(resp.apiBody.emlNtfyRecvYn);
            setSmsNtfyRecvYn(resp.apiBody.smsNtfyRecvYn);
            setSmsNtfyRecvYnDraft(resp.apiBody.smsNtfyRecvYn);
            emlNtfyRecvYnRef.current = resp.apiBody.emlNtfyRecvYn;
            smsNtfyRecvYnRef.current = resp.apiBody.smsNtfyRecvYn;

            if (!hasLoadedInitialMktgInfo.current) {
                hasLoadedInitialMktgInfo.current = true;
                const isInitAgreed = resp.apiBody?.smsNtfyRecvYn === "Y";
                setIsInitialSmsAgreed(isInitAgreed);
                if (isInitAgreed) {
                    setSmsApplyDateText(getSmsApplyDateText(resp.apiBody));
                }
            }
        });
        },[])
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_ATHN_CHNG_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{txt.pageTitle}</p>
            </div>
            <div className="myPageSubCtxtWrap">
            
                {/* email인증회원은 휴대폰인증으로 인증방식 변경이 가능합니다. */}
                <div className={`idntMthdChngTxtWrap ingameIdntMthdChngTxtWrap ${showAddrSection ? "" : "noAddrSection"}`}>
                    <div className='idntMthdChngTxt ingameAuthCard'>
                        <h2 className="idntMthdChngTitl">{isSmsOnlyMode ? txt.smsOnlyTitle : txt.authTitle}</h2>
                        <p className="ingameDescTxt">
                            {isSmsOnlyMode ? txt.smsOnlyDesc : (
                                <>
                                    {txt.authDesc}  <br />
                                    {txt.authDesc2}
                                </>
                            )}
                        </p>
                        {!isSmsOnlyMode && (
                            <div className="idntMthdChngImgWrap">
                                <img src={process.env.PUBLIC_URL+'/images/MbpAthnIcon.png'} alt="" />
                            </div>
                        )}
                        <div className="ingameAgreeWrap">
                            <input type="checkbox" name='agreSmsNtfy' className='agreChkBox' id='agreSmsNtfy' checked={smsNtfyRecvYnDraft=="Y"} onChange={AgreSmsNtfyFunc} disabled={isInitialSmsAgreed}/>
                            <label htmlFor="agreSmsNtfy">
                                {langData&&langData.MYPAGE_MAIN_SMS_NTFY_LBL_00}
                                {/* SMS 알림 수신 동의 */}
                            </label>
                        </div>
                        {isInitialSmsAgreed && (
                            <p className="ingameAgreeStatusTxt">
                                {txt.smsAgreeDone}
                                {smsApplyDateText ? ` (${txt.applyDateLabel}: ${smsApplyDateText})` : ""}
                            </p>
                        )}
                        {isSmsOnlyMode ? (
                            <button type="button" className="postcodeConfirmBtn" onClick={submitSmsConsentOnly}>
                                <p>{txt.confirmBtn}</p>
                            </button>
                        ) : isInitialPhoneAuthed ? (
                            <button type="button" className="postcodeConfirmBtn isDone" disabled>
                                <p>{txt.authDone}</p>
                            </button>
                        ) : (
                            <MbpAthnUi athnPrpsCd={"MTHD_CHNG"} AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00} BtnClass={"postcodeConfirmBtn"} smsNtfyRecvYnRef={smsNtfyRecvYnRef}/>
                        )}
                    </div>
                    {showAddrSection && (
                    <div className="postcodeSearchWrap ingameAddressCard">
                        <h2 className="idntMthdChngTitl">{txt.addrTitle}</h2>
                        <p className="ingameDescTxt">{renderTextWithBr(txt.addrDesc)}</p>
                        <div className="postcodeRow">
                            <div className="postcodeInputWithBtn">
                                <input className="postcodeInput" value={zipCode} readOnly placeholder={txt.zipPlaceholder} onClick={openPostcodeModal} />
                                <button type="button" className="postcodeInputActionBtn" onClick={openPostcodeModal}>{txt.zipSearchBtn}</button>
                            </div>
                        </div>
                        <div className="postcodeRow singleRow">
                            <input className="postcodeInput" value={roadAddress} readOnly placeholder={txt.roadPlaceholder} onClick={openPostcodeModal} />
                        </div>
                        {isOpen && (
                            <div
                                className="postcodeModalOverlay"
                                onClick={() => setIsOpen(false)}
                                role="dialog"
                                aria-modal="true"
                            >
                                <div
                                    className="postcodeModalContent"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="postcodeModalHeader">
                                        <span>{txt.modalTitle}</span>
                                        <button
                                            type="button"
                                            className="postcodeModalCloseBtn"
                                            onClick={() => setIsOpen(false)}
                                        >
                                            {txt.closeBtn}
                                        </button>
                                    </div>
                                    <DaumPostcode onComplete={completeHandler} style={{ height: '100%' }} />
                                </div>
                            </div>
                        )}
                        <div className="postcodeRow singleRow">
                            <input className="postcodeInput" type="text" onChange={changeHandler} value={detailAddress} placeholder={txt.detailPlaceholder}/>
                        </div>
                        <div className="ingameAgreeWrap">
                            <input type="checkbox" name='agreSmsNtfyAddr' className='agreChkBox' id='agreSmsNtfyAddr' checked={addrInfoAgreeYn=="Y"} onChange={AgreAddrInfoFunc}/>
                            <label htmlFor="agreSmsNtfyAddr">
                                {txt.addrAgreeLabel}
                                {/* SMS 알림 수신 동의 */}
                            </label>
                        </div>
                        <div className="postcodeActionWrap">
                            <button type="button" className="postcodeConfirmBtn" onClick={clickHandler}>
                                <p>{txt.confirmBtn}</p>
                            </button>
                        </div>
                    </div>
                    )}
                </div>
            </div> 
        </div>
        </>
    )
}

export default MembIngameIdntMthdChngUi;